import { render, staticRenderFns } from "./ScansAndFiles.vue?vue&type=template&id=2e5c674d"
import script from "./ScansAndFiles.vue?vue&type=script&lang=js"
export * from "./ScansAndFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports